module.exports = __webpack_public_path__ + "static/media/medal.540db97f.png";